<template>
    <div class="warpper">
        <div class="edit-box">
            <div class="notice-title padding-sm margin-bottom-sm">
                <div class="flex align-start justify-between margin-bottom-sm">
                    <h3 class="notice-title-text">发布通知</h3>
                    <router-link to>
                        <el-button
                            class="blue-btn"
                            round
                            type="primary"
                            @click="$router.go(-1)"
                        >返回
                        </el-button
                        >
                    </router-link>
                </div>
                <el-form
                    ref="noticeForm"
                    :model="noticeForm"
                    :rules="rules"
                    class="demo-noticeForm"
                    label-width="120px"
                >
                    <el-form-item label="通知标题" prop="title">
                        <el-input
                            v-model="noticeForm.title"
                            placeholder="请输入通知标题"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="通知类型" prop="notice_type">
                        <el-radio-group v-model="noticeForm.notice_type" :disabled="noticeId !==0">
                            <el-radio :label="0">普通通知</el-radio>
                            <el-radio :label="1">反馈通知</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="通知文本" prop="content">
                        <VueUditorWrap
                            v-model="noticeForm.content"
                            :config="myConfig"
                        ></VueUditorWrap>
                    </el-form-item>
                    <el-form-item label="通知附件">
                        <el-upload
                            ref="upload3"
                            :action="fileUpUrl"
                            :before-remove="beforeRemove"
                            :before-upload="beforeAvatarUpload"
                            :data="QiniuData"
                            :file-list="fileList3"
                            :name="'file'"
                            :on-preview="handlePreview"
                            :on-success="handleAvatarSuccess3"
                            multiple
                        >
                            <div class="flex align-center">
                                <el-button class="blue-btn margin-right" round> + 点击上传附件</el-button>
                                文件不能超过50M
                            </div>
                        </el-upload>
                    </el-form-item>

                    <el-form-item  label="发送会员" prop="send2user">
                        <el-button
                            v-if="!allChiose"
                            class="margin-right blue-btn"
                            round
                            style="width: 143px"
                            type="primary"
                            @click="chioseDialog = true"
                        >
                            {{
                                noticeForm.send2user.length === 0
                                    ? "会员选择"
                                    : "已选择" + noticeForm.send2user.length + "家会员"
                            }}
                        </el-button>
                        <el-checkbox v-model="allChiose"  @change="changeCheck">全部会员</el-checkbox>
                    </el-form-item>

                    <el-form-item v-if="false" label="发送会员">
                        <el-button
                            class="margin-right blue-btn"
                            style="width: 143px"
                            round
                            type="primary"
                            @click="chioseDialog = true"
                        >
                            {{
                                noticeForm.send2user.length === 0
                                    ? "会员选择"
                                    : "已选择" + noticeForm.send2user.length + "家会员"
                            }}
                        </el-button>
                    </el-form-item>
                    <el-form-item
                        v-if="noticeForm.notice_type === 1 && noticeId === 0"
                        label="反馈表单"
                    >
                        <div class="ship-list">
                            <el-table
                                :data="noticeForm.diy_form"
                                alig="center"
                                fit
                                header-row-class-name="table-header"
                                row-class-name="table-row"
                                style="width: 100%"
                            >
                                <el-table-column label="表单项">
                                    <template slot-scope="scope">
                                        <div
                                            v-if="Number(scope.row.type) === 1"
                                            class="table-item padding-left-sm flex align-center"
                                        >
                                            <p>
                      <span v-if="Number(scope.row.state) === 1">*</span
                      >{{ scope.row.name }}:
                                            </p>
                                            <input :placeholder="scope.row.placeholder" type="text"/>
                                        </div>
                                        <div
                                            v-if="Number(scope.row.type) === 2"
                                            class="table-item padding-left-sm flex align-start"
                                        >
                                            <p>
                                                <span v-if="Number(scope.row.state) === 1">*</span>
                                                {{ scope.row.name }}:
                                            </p>
                                            <textarea :placeholder="scope.row.placeholder"></textarea>
                                        </div>
                                        <div
                                            v-if="Number(scope.row.type) === 3"
                                            class="table-item padding-left-sm"
                                        >
                                            <p>
                                                <span v-if="Number(scope.row.state) === 1">*</span>
                                                {{ scope.row.name }}
                                            </p>
                                            <div class="flex align-center flex-wrap">
                                                <p
                                                    v-for="items in scope.row.option"
                                                    :key="items"
                                                    class="flex align-center margin-right"
                                                >
                                                    <input class="radio" disabled type="radio"/><i
                                                    class="margin-left-xs"
                                                >{{ items }}</i>
                                                </p>
                                            </div>
                                        </div>
                                        <div
                                            v-if="Number(scope.row.type) === 4"
                                            class="table-item padding-left-sm"
                                        >
                                            <p>
                                                <span v-if="Number(scope.row.state) === 1">*</span>
                                                {{ scope.row.name }}
                                            </p>
                                            <div class="flex align-center flex-wrap">
                                                <p
                                                    v-for="items in scope.row.option"
                                                    :key="items"
                                                    class="flex align-center margin-right"
                                                >
                                                    <input class="radio" disabled type="checkbox"/>
                                                    <i class="margin-left-xs">{{ items }}</i>
                                                </p>
                                            </div>
                                        </div>
                                        <div
                                            v-if="Number(scope.row.type) === 5"
                                            class="table-item padding-left-sm"
                                        >
                                            <p>
                                                <span v-if="Number(scope.row.state) === 1">*</span>
                                                {{ scope.row.name }}
                                            </p>
                                            <div class="flex align-center flex-wrap">
                                                <el-button round class="blue-btn margin-left-xs">点击上传附件</el-button>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="类型" width="100px">
                                    <template slot-scope="scope">
                                        <div class="table-item">
                                            {{ scope.row.type | type }}
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column label="状态" width="100px">
                                    <template slot-scope="scope">
                                        <div class="table-item">
                                            {{ Number(scope.row.state) === 1 ? "必填" : "选填" }}
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column label="操作" width="200px">
                                    <template v-if="scope.$index > -1" slot-scope="scope">
                                        <div class="table-operate">
                                            <el-button
                                                round
                                                size="medium"
                                                type="primary"
                                                @click="editItem(scope.$index)"
                                            >编辑
                                            </el-button>
                                            <el-button
                                                round
                                                size="medium"
                                                type="danger"
                                                @click="deleteItem(scope.$index)"
                                            >删除
                                            </el-button>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>


                        <div class="flex align-center justify-around margin-tb ">
                            <el-button
                                round
                                style="width: 200px"
                                type="primary"
                                @click="signupDialog = true"
                            >添加
                            </el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label-width="0">
                        <div class="flex justify-center">
                            <el-button
                                v-if="!noticeId"
                                class="padding-lr-xl blue-btn"
                                round
                                style="width: 220px"
                                type="primary"
                                @click="submitForm('noticeForm')"
                            >发布
                            </el-button>
                            <el-button
                                v-else
                                class="padding-lr-xl blue-btn"
                                round
                                style="width: 220px"
                                type="primary"
                                @click="upDataForm('noticeForm')"
                            >更新
                            </el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <signup-dialog
            :setIndex="setIndex"
            :setItem="setItem"
            :signupDialog="signupDialog"
            @cancelDialog="cancelDialog"
        />
        <chiose-dialog
            :chioseDialog="chioseDialog"
            :send_user_id="send_user_id"
            @cancelChiose="cancelChiose"
            @saveChiose="saveChiose"
        />
    </div>
</template>

<script>
import signupDialog from "@/components/signupDialog";
import chioseDialog from "./../../components/ChioseDialog";
import VueUditorWrap from 'vue-ueditor-wrap'
import {filePath, fileUpUrl} from '@/config/index'
import {bdEditConfig, zhDate} from "@/utils/utils"
import {noticeAdd, noticeDetail, noticeEdit, allMember} from "@/api/branch";
import {genUpToken} from "@/utils/CryptoJS";

export default {
    name: "edit",
    data() {
        var validateUser = (rule, value, callback) => {
            if (value.length === 0 && !this.allChiose) {
                callback(new Error('请选择发送会员'));
            } else {
                callback();
            }
        };
        return {
            noticeId: '',
            myConfig: bdEditConfig(),
            noticeForm: {
                title: '',
                content: '',
                attached_file: [],
                notice_type: 0,
                send2user: [],
                delivery: false,
                total: 0,
                signup_num: 1,
                is_send_sms: 0,
                diy_form: []
            },
            rules: {
                title: [
                    {required: true, message: '请输入通知标题', trigger: 'blur'},
                ],
                content: [
                    {required: true, message: '请输入通知文本', trigger: 'blur'},
                ],
                notice_type: [
                    {required: true, message: '请选择通知类型', trigger: 'change'}
                ],
                send2user: [
                    {required: true, validator: validateUser, trigger: 'change'}
                ],
            },
            fileList3: [],
            send_user_id: [],
            allChiose: false,
            signupDialog: false,
            setIndex: -1,
            setItem: {},
            chioseDialog: false,
            chioseType: 1,
            QiniuData: {
                fname: '', //  文件名
                key: '', //文件名字处理
                token: genUpToken() //七牛云token
            },
            fileUpUrl: fileUpUrl,
            hasMember:false
        }
    },
    created() {
        this.$emit('setIndex', [1, 0], '通知公告')
        this.noticeId = Number(this.$route.params.id)
        if (this.noticeId) this.getDetail()
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    components: {
        VueUditorWrap,
        signupDialog,
        chioseDialog
    },
    methods: {
        //  获取全部标签和会员
        async init() {
            let _allMember = await allMember()
            if (_allMember.data.length > 0){
                this.hasMember = true
            }
        },
        changeCheck(e){
            if (e && !this.hasMember ){
                this.allChiose = false
                this.$message.error('您还没有会员')
            }
        },
        async upData() {
            let _state = await noticeEdit(
                this.noticeForm.title,
                this.noticeForm.content,
                JSON.stringify(this.noticeForm.attached_file),
                this.allChiose ? 0 : this.noticeForm.send2user.join(','),
                this.noticeId
            )
            if (_state.status === 200) {
                this.$message.success('发布成功')
                this.$router.go(-1)
            }
        },
        //  更新通知公告
        upDataForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.upData()
                } else {
                    this.$message.error('通知公告信息未填写完整，请检查！')
                }
            });
        },

        async submitData() {
            let _state = await noticeAdd(
                this.noticeForm.title,
                this.noticeForm.notice_type,
                this.noticeForm.content,
                JSON.stringify(this.noticeForm.attached_file),
                this.allChiose ? 0 : this.noticeForm.send2user.join(','),
                this.noticeForm.notice_type === 1 ? JSON.stringify(this.noticeForm.diy_form) : JSON.stringify([]),
            )
            if (_state.status === 200) {
                this.$message.success('发布成功')
                this.$router.go(-1)
            }
        },
        //  发布通知公告
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData()
                } else {
                    this.$message.error('通知公告信息未填写完整，请检查！')
                }
            });
        },

        //  标签选择保存发送人员
        saveChiose(val) {
            this.chioseType = val[0]
            this.noticeForm.send2user = val[1]
            this.cancelChiose()
        },
        //  关闭弹框
        cancelChiose() {
            this.chioseDialog = false
        },
        //  编辑表单项
        editItem(index) {
            this.setItem = this.noticeForm.diy_form[index];
            this.setIndex = index;
            this.signupDialog = true;
        },
        //  删除表单项
        deleteItem(index) {
            this.$confirm("确定要删除吗？", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.noticeForm.diy_form.splice(index, 1)
            });
        },
        //  关闭表单弹窗
        cancelDialog(val) {
            if (val[0]) {
                if (this.setIndex === -1) {
                    this.noticeForm.diy_form.push(val[1])
                } else {
                    this.$set(this.noticeForm.diy_form, this.setIndex, val[1])
                }
            }
            this.setIndex = -1;
            this.setItem = {};
            this.signupDialog = false;
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;

            if (!isLt2M) {
                this.$message.error('上传附件大小不能超过 50MB!');
                return false;
            }
            this.QiniuData.fname = file.name;
            this.QiniuData.key = `${new Date().getTime()}${file.name}`
            this.uping = this.$loading({
                lock: true,
                text: "上传中，请稍后",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.2)",
            });
        },
        //  上传成功
        handleAvatarSuccess3(res, file) {
            this.uping.close();
            this.noticeForm.attached_file.push(
                {
                    name: file.name,
                    url: `${filePath}/${res.key}`
                }
            )
            this.fileList3 = this.noticeForm.attached_file

        },
        // 上传失败
        handleExceed() {
            this.$message.error('上传失败，请重新上传！')
        },
        //上传文件预览
        handlePreview(file) {
            window.open(file.url)
        },
        //  删除上传文件
        beforeRemove(file, fileList) {
            this.noticeForm.attached_file = fileList
            this.fileList3 = fileList
        },

        //  获取通知公告信息
        async getDetail() {
            let _data = await noticeDetail(this.noticeId)
            this.noticeForm.title = _data.data.title
            this.noticeForm.content = _data.data.content
            this.noticeForm.notice_type = _data.data.is_feedback
            this.noticeForm.attached_file = JSON.parse(_data.data.file_json)
            this.send_user_id = _data.data.send_user_id
            this.noticeForm.send2user = this.send_user_id.map(item=>{
                    return item.user_id
                }
            )
            this.fileList3 = this.noticeForm.attached_file
        }
    },
    filters: {
        tiem(val) {
            return zhDate(val * 1000)
        },
        type(num) {
            switch (Number(num)) {
                case 1:
                    return '单行文本'
                case 2:
                    return '多行文本'
                case 3:
                    return '单选'
                case 4:
                    return '多选'
                case 5:
                    return '附件'
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.warpper {
    .edit-box {
        background: #fff;
        border-radius: 10px;

        .notice-title-text {
            width: 80%;
            font-size: 26px;
            line-height: 40px;
            color: #333333;
        }
    }

    .table-item {
        display: flex;
        align-items: center;

        p {
            min-width: 100px;

            span {
                color: #e4396c;
            }
        }

        input {
            display: block;
            height: 40px;
            padding: 0 10px;
            border: 1px solid #eee;
            margin-left: 10px;
        }

        input.radio {
            margin: 0;
        }

        textarea {
            display: block;
            border: 1px solid #eee;
            height: 60px;
            padding: 0 10px;
            margin-left: 10px;
        }
    }
}
</style>